exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'Roboto';\n  src: local(\"Roboto\"), local(\"Roboto-Regular\"), url(\"/static/fonts/Roboto-Regular.woff2\") format(\"woff2\"), url(\"/static/fonts/Roboto-Regular.woff\") format(\"woff\"), url(\"/static/fonts/Roboto-Regular.ttf\") format(\"truetype\"); }\n\n@font-face {\n  font-family: 'Lato';\n  src: local(\"Lato\"), local(\"Lato-Regular\"), url(\"/static/fonts/Lato-Regular.woff2\") format(\"woff2\"), url(\"/static/fonts/Lato-Regular.woff\") format(\"woff\"), url(\"/static/fonts/Lato-Regular.ttf\") format(\"truetype\"); }\n\nhtml, body, #root {\n  width: 100%;\n  min-width: 320px;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  font-family: 'Roboto'; }\n\nhtml {\n  box-sizing: border-box; }\n\n*, *:before, *:after {\n  box-sizing: inherit; }\n\nbody {\n  background: linear-gradient(117deg, #120a20 0%, #00122f 45%, #01334a 100%);\n  background-attachment: fixed; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/style.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/style.scss
// module chunks = index